export default "{\n    \"heading\": \"Change Request Type\",\n    \"repairRequestTitle\": \"Vendor Request\"\n}\n"